import { MappedClass, MappedProperty, MappedPropertyCurrency } from '@h5s/util-object';
import Big from 'big.js';
import { Stay } from './stay';

export interface CreateStayFields {
  available: boolean | null;
  basePrice: Big | null;
  costCenterId: number | null;
  defaultPriceListId: number | null;
  departmentId: number | null;
  description: string | null;
  descriptionDe: string | null;
  descriptionEn: string | null;
  descriptionEs: string | null;
  descriptionFr: string | null;
  exportCode: string | null;
  id: number | null;
  notes: string | null;
  notesDe: string | null;
  notesEn: string | null;
  notesEs: string | null;
  notesFr: string | null;
  priceLists: number[] | null;
  vat: Big | null;
  vatRateId: number | null;
  addedBedFixed: boolean | null;
  addedJuniorBedFixed: boolean | null;
  ageAddedCradle: number | null;
  ageAddedJuniorBed: number | null;
  breakfast: boolean | null;
  channelManagerCode: string | null;
  channelManagerPriceListId: number | null;
  dinner: boolean | null;
  endpointCode: string | null;
  extraBreakfast: Big | null;
  extraDinner: Big | null;
  extraLunch: Big | null;
  lunch: boolean | null;
  maxNumberOfGuests: number | null;
  maxPrice: Big | null;
  minPrice: Big | null;
  numberOfGuests: number | null;
  onlyOta: boolean | null;
  priceAddedBed: Big | null;
  priceAddedCradle: Big | null;
  priceAddedJuniorBed: Big | null;
  rateManagerCode: string | null;
  realStayId: number | null;
  shortDescription: string | null;
  virtual: boolean | null;
  webOrder: number | null;
}

@MappedClass()
export class CreateStay implements CreateStayFields {
  @MappedProperty()
  available: boolean | null = null;

  @MappedPropertyCurrency()
  basePrice: Big | null = null;

  @MappedProperty()
  costCenterId: number | null = null;

  @MappedProperty()
  defaultPriceListId: number | null = null;

  @MappedProperty()
  departmentId: number | null = null;

  @MappedProperty()
  description: string | null = null;

  @MappedProperty()
  descriptionDe: string | null = null;

  @MappedProperty()
  descriptionEn: string | null = null;

  @MappedProperty()
  descriptionEs: string | null = null;

  @MappedProperty()
  descriptionFr: string | null = null;

  @MappedProperty()
  exportCode: string | null = null;

  @MappedProperty()
  id: number | null = null;

  @MappedProperty()
  notes: string | null = null;

  @MappedProperty()
  notesDe: string | null = null;

  @MappedProperty()
  notesEn: string | null = null;

  @MappedProperty()
  notesEs: string | null = null;

  @MappedProperty()
  notesFr: string | null = null;

  @MappedProperty()
  priceLists: number[] | null = null;

  @MappedPropertyCurrency()
  vat: Big | null = null;

  @MappedProperty()
  vatRateId: number | null = null;

  @MappedProperty()
  addedBedFixed: boolean | null = null;

  @MappedProperty()
  addedJuniorBedFixed: boolean | null = null;

  @MappedProperty()
  ageAddedCradle: number | null = null;

  @MappedProperty()
  ageAddedJuniorBed: number | null = null;

  @MappedProperty()
  breakfast: boolean | null = null;

  @MappedProperty()
  channelManagerCode: string | null = null;

  @MappedProperty()
  channelManagerPriceListId: number | null = null;

  @MappedProperty()
  dinner: boolean | null = null;

  @MappedProperty()
  endpointCode: string | null = null;

  @MappedPropertyCurrency()
  extraBreakfast: Big | null = null;

  @MappedPropertyCurrency()
  extraDinner: Big | null = null;

  @MappedPropertyCurrency()
  extraLunch: Big | null = null;

  @MappedProperty()
  lunch: boolean | null = null;

  @MappedProperty()
  maxNumberOfGuests: number | null = null;

  @MappedPropertyCurrency()
  maxPrice: Big | null = null;

  @MappedPropertyCurrency()
  minPrice: Big | null = null;

  @MappedProperty()
  numberOfGuests: number | null = null;

  @MappedProperty()
  onlyOta: boolean | null = null;

  @MappedPropertyCurrency()
  priceAddedBed: Big | null = null;

  @MappedPropertyCurrency()
  priceAddedCradle: Big | null = null;

  @MappedPropertyCurrency()
  priceAddedJuniorBed: Big | null = null;

  @MappedProperty()
  rateManagerCode: string | null = null;

  @MappedProperty()
  realStayId: number | null = null;

  @MappedProperty()
  shortDescription: string | null = null;

  @MappedProperty()
  virtual: boolean | null = null;

  @MappedProperty()
  webOrder: number | null = null;

  constructor(fields?: CreateStayFields) {
    Object.assign(this, fields);
  }

  public static fromStay(data: Stay): CreateStay {
    return new CreateStay({
      available: data.available ?? null,
      basePrice: data.basePrice ?? null,
      costCenterId: data.costCenterId ?? null,
      defaultPriceListId: data.defaultPriceListId ?? null,
      departmentId: data.departmentId ?? null,
      description: data.description ?? null,
      descriptionDe: data.descriptionDe ?? null,
      descriptionEn: data.descriptionEn ?? null,
      descriptionEs: data.descriptionEs ?? null,
      descriptionFr: data.descriptionFr ?? null,
      exportCode: data.exportCode ?? null,
      id: data.id ?? null,
      notes: data.notes ?? null,
      notesDe: data.notesDe ?? null,
      notesEn: data.notesEn ?? null,
      notesEs: data.notesEs ?? null,
      notesFr: data.notesFr ?? null,
      priceLists: data.priceLists.map((p) => p.id),
      vat: data.vat ?? null,
      vatRateId: data.vatRateId ?? null,
      addedBedFixed: data.addedBedFixed ?? null,
      addedJuniorBedFixed: data.addedJuniorBedFixed ?? null,
      ageAddedCradle: data.ageAddedCradle ?? null,
      ageAddedJuniorBed: data.ageAddedJuniorBed ?? null,
      breakfast: data.breakfast ?? null,
      channelManagerCode: data.channelManagerCode ?? null,
      channelManagerPriceListId: data.channelManagerPriceListId ?? null,
      dinner: data.dinner ?? null,
      endpointCode: data.endpointCode ?? null,
      extraBreakfast: data.extraBreakfast ?? null,
      extraDinner: data.extraDinner ?? null,
      extraLunch: data.extraLunch ?? null,
      lunch: data.lunch ?? null,
      maxNumberOfGuests: data.maxNumberOfGuests ?? null,
      maxPrice: data.maxPrice ?? null,
      minPrice: data.minPrice ?? null,
      numberOfGuests: data.numberOfGuests ?? null,
      onlyOta: data.onlyOta ?? null,
      priceAddedBed: data.priceAddedBed ?? null,
      priceAddedCradle: data.priceAddedCradle ?? null,
      priceAddedJuniorBed: data.priceAddedJuniorBed ?? null,
      rateManagerCode: data.rateManagerCode ?? null,
      realStayId: data.realStayId ?? null,
      shortDescription: data.shortDescription ?? null,
      virtual: data.virtual ?? null,
      webOrder: data.webOrder ?? null,
    });
  }
}
